import type { IUnifiedOrderBlotterEntry } from 'apiConnector/blotters';
import type { IBlotterPreferenceState } from 'components/shared/Blotter/Grid/blotter.model';
import { emptyBlotterPreferences } from 'components/shared/Blotter/Grid/blotter.model';
import type { IBlotterColumnDefinition, SortDirection } from 'state/blotters/common/blotter.model';

interface ISecondaryMarketOrderBlotter {
  columnDefinition: readonly IBlotterColumnDefinition<IUnifiedOrderBlotterEntry>[];
  blotterPreferenceState: IBlotterPreferenceState;
  sort?: string;
  sortDir: SortDirection;
  loading: boolean;
  error: boolean;
  items?: readonly IUnifiedOrderBlotterEntry[];
  areBlotterPreferencesInError: boolean;
  displayedItemsCnt: number;
  canSaveBlotterPreferences: boolean;
}

export type SecondaryMarketOrderBlotterState = Readonly<ISecondaryMarketOrderBlotter>;
export const initialSecondaryMarketOrderBlotterState: SecondaryMarketOrderBlotterState = {
  blotterPreferenceState: emptyBlotterPreferences,
  columnDefinition: [],
  sortDir: 'asc',
  loading: true,
  error: false,
  areBlotterPreferencesInError: false,
  displayedItemsCnt: 0,
  canSaveBlotterPreferences: false,
};
